(function () {
    const jQuery = window.jQuery
        ? window.jQuery
        : window.Checkout && window.Checkout.$
            ? window.Checkout.$
            : false;

    const baseUrl = "https://"+window.OsGlobals.domain;
    window.OsGlobals.jQuery = jQuery;
    window.OsGlobals.baseUrl = baseUrl;

    window.OsFields = window.OsFields || {};
})();

if (window.location.href.indexOf("personal-shopping") > -1) {
    psPage = true;
} else {
    psPage = false;
} 
(function ($) {

    window.OsFields.inputDeliverySection = {};

    $(".js-onstate-input-collect-postcode--submit").on("click", function (e) {
        e.preventDefault();
        var postCodeVal = $(".js-onstate-input-collect-postcode").val();
        var currentLocation = false;
        $(".js-onstate-store-list-wrapper").empty().append("<div class='loading'>"+ theme.strings.findStoreLoading +"</div>");
        getStoreCollectionAddresses(postCodeVal, currentLocation).then(function(){listStoreCollectionAddresses(postCodeVal);});
    });

    // Get the input field
    var input = document.getElementById("js-search-stores-input");

    // Execute a function when the user releases a key on the keyboard
    input.addEventListener("keyup", function(event) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            document.getElementById("js-search-stores-btn").click();
        }
    });

    function getStoreCollectionAddresses(postCodeVal, currentLocation) {
        var postCode = postCodeVal;
        var sku;

        var product = JSON.parse($("#ProductJson-product-template").text());
        if (document.getElementById('buy-for-baby')) {
            var sku = document.querySelector('#storeDropdown').getAttribute('product-sku');
            //sku = '779502703';
        } else {
            if(product.variants.length == 1) {
                sku = product.variants[0].sku;
            } else {
                sku = $(".selector input:checked").attr('data-variant-sku');
            }
        }

        return new Promise((resolve, reject) => {
            let src = ""
            if (currentLocation) {
                src =
                    window.OsGlobals.baseUrl
                    + "/googlemaps/stores.js"
                    + "?callback=callbackStoreCollectionAddresses"
                    + "&address=" + postCode
                    + "&currentLocation=true"
                    + "&basket["+sku+"]=1"
            } else {
                src =
                    window.OsGlobals.baseUrl
                    + "/googlemaps/stores.js"
                    + "?callback=callbackStoreCollectionAddresses"
                    + "&address=" + postCode
                    + "&basket["+sku+"]=1"
            }

            let loadScript = document.createElement("script");

            loadScript.onload = resolve;
            loadScript.onerror = reject;

            loadScript.async = true;
            loadScript.src = src;
            document.getElementsByTagName("head")[0].appendChild(loadScript);
        });
    }

    function listStoreCollectionAddresses(yourPostCodeVal) {

        if(window.OsFields.inputDeliverySection.collectionAddresses.stores == undefined) {
            $(".js-onstate-store-list-wrapper").empty().append("<div class='message'>"+ theme.strings.findStoreMessageNoResult +"</div>");
        } else {
            $(".js-onstate-store-list-wrapper").empty();
            if ( psPage == true ) {
                var storeToolTip = ''
            } else { 
             var storeToolTip = `
                <div class='onstate-store-notice-wrapper'>
                    <div class='onstate-store-notice'>
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon-footer-info" width="18" height="18" viewBox="0 0 18 18">
                            <g transform="translate(1 1)">
                                <line id="Line_17" data-name="Line 17" y2="7" transform="translate(8 6)" fill="none" stroke="#323232" stroke-width="2"></line>
                                <line id="Line_18" data-name="Line 18" x1="4" transform="translate(6 12)" fill="none" stroke="#323232" stroke-width="2"></line>
                                <line id="Line_21" data-name="Line 21" x1="2" transform="translate(6 7)" fill="none" stroke="#323232" stroke-width="2"></line>
                                <line id="Line_20" data-name="Line 20" y2="2" transform="translate(8 3)" fill="none" stroke="#323232" stroke-width="2"></line>
                                <circle id="Ellipse_84" data-name="Ellipse 84" cx="8" cy="8" r="8" stroke-width="2" stroke="#323232" stroke-linecap="round" stroke-linejoin="round" fill="none"></circle>
                            </g>
                        </svg>
                        <span>${theme.strings.findStoreNoticeTitle}</span>
                    </div>
                    <div class='onstate-store-notice-message hide'>
                        <div class='onstate-store-notice-message-wrapper'>
                            ${theme.strings.findStoreNoticeMessage}
                        </div>
                    </div>
                </div>
            `;
            }

            var storeToolTipElement = $(storeToolTip);
            $(".js-onstate-store-list-wrapper").append(storeToolTipElement)

            for (i in window.OsFields.inputDeliverySection.collectionAddresses.stores) {
                storeData = window.OsFields.inputDeliverySection.collectionAddresses.stores[i];
                
                var storeAddress = []
                if (storeData.address1.length != 0) {
                    storeAddress.push(storeData.address1)
                }
                if (storeData.address2.length != 0) {
                    storeAddress.push(storeData.address2)
                }
                if (storeData.address3.length != 0) {
                    storeAddress.push(storeData.address3)
                }
                storeAddress.push(storeData.town, storeData.postCode)
                storeAddress = storeAddress.join("<br />");

                var yourPostCode = yourPostCodeVal;

                var hide = '';
                if (i >= 5) {
                    hide = "style='display:none;'";
                }

                var dist = storeData.distance.distance.text
                if ( psPage == true ) {
                    /* EXCLUDES CARLISLE STORE FROM RETURNED LIST */
                    if (storeData.mpStoreId != 'C904001') {
                    var storeItem = `
                    <div id="${storeData.mpStoreId}" class="content-box__row js-onstate-store-item" data-onstate-store data-onstate-store-id="${storeData.mpStoreId}" ${hide}>
                        <strong><span class='onstate-store-title' data-onstate-store-title>${storeData.displayName}</span></strong>
                        <div><div class='onstate-store-address' data-onstate-store-address>${storeAddress}</div></div>
                        <div class='onstate-store-distance-wrapper'>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon-header-stores" viewBox="0 0 15 18.7">
                                <path class="st0" d="M7.5,1.1c3.5,0,6.4,2.9,6.4,6.4c0,3.5-6.4,9.6-6.4,9.6s-6.4-6.1-6.4-9.6C1.1,4,4,1.1,7.5,1.1z" fill="none" stroke="#323232" stroke-width="2" vector-effect="non-scaling-stroke"></path>
                                <path class="st1" d="M7.5,8.5c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2S8.2,8.5,7.5,8.5z" fill="#323232"></path>
                            </svg>
                            <span class='onstate-store-distance' data-onstate-store-distance>${dist}</span>&nbsp;from&nbsp;<span class='onstate-destination-postcode' data-onstate-destination-postcode>${yourPostCode}</span>
                        </div>
                        <button class="js-onstate-input-store-select--submit btn btn--solid-color appointedd-booking-popover" ap-appid="" onclick="selectStore()">Choose this store</button>
                    </div>
                `;
                                        
                 }
                } else {
                var storeItem = `
                    <div class="content-box__row js-onstate-store-item" data-onstate-store data-onstate-store-id="${storeData.mpStoreId}" ${hide}>
                        <strong><span class='onstate-store-title' data-onstate-store-title>${storeData.displayName}</span></strong>
                        <div><div class='onstate-store-address' data-onstate-store-address>${storeAddress}</div></div>
                        <div class='onstate-store-distance-wrapper'>
                            <svg aria-hidden="true" focusable="false" role="presentation" class="icon-header-stores" viewBox="0 0 15 18.7">
                                <path class="st0" d="M7.5,1.1c3.5,0,6.4,2.9,6.4,6.4c0,3.5-6.4,9.6-6.4,9.6s-6.4-6.1-6.4-9.6C1.1,4,4,1.1,7.5,1.1z" fill="none" stroke="#323232" stroke-width="2" vector-effect="non-scaling-stroke"></path>
                                <path class="st1" d="M7.5,8.5c-0.7,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2S8.2,8.5,7.5,8.5z" fill="#323232"></path>
                            </svg>
                            <span class='onstate-store-distance' data-onstate-store-distance>${dist}</span>&nbsp;from&nbsp;<span class='onstate-destination-postcode' data-onstate-destination-postcode>${yourPostCode}</span>
                        </div>
                        <div class='onstate-store-stock-wrapper'>
                            <span class='onstate-store-availability' data-onstate-store-availability>${storeData.availability}</span>
                        </div>
                        <!-- button class="js-onstate-input-store-select--submit btn btn--solid-color" data-onstate-store-id="${storeData.mpStoreId}" data-onstate-store-idx="${i}">${theme.strings.findStoreAddItem}</button -->
                    </div>
                `;
                }

                var storeElement = $(storeItem);

               

                /*/
                storeElement.on("click", ".js-onstate-input-store-select--submit", function (e) {
                    e.preventDefault();
                    
                    var idx = $(this).attr('data-onstate-store-idx');
                    var storeId = $(this).attr('data-onstate-store-id');
                    
                    var storeData = window.OsFields.inputDeliverySection.collectionAddresses.stores[idx];

                    window.localStorage.collectionStore = [
                        storeData.displayName,
                        storeData.address1,
                        storeData.address2,
                        storeData.town,
                        storeData.postCode,
                        storeData.phone
                    ].join(", ");

                    $("#store-locator button.btn--close").trigger("click");


                    $('form.product-form').submit();

                    $(".js-onstate-input-store-select--submit").not(this).removeClass("btn--subdued");

                    var collectionStoreStr = "<address>" + window.localStorage.collectionStore + "</address>";

                    $(".collection-summary.js-collection-summary").remove();

                    $("label", $("#js-onstate-input-collect-postcode").closest(".radio-wrapper")).append("<div class='collection-summary js-collection-summary'><span>Collection from: " + collectionStoreStr + "</span><a href='#'>Change</a></div>");

                    $(".fieldset.js-onstate-input-collect-postcode--wrapper").hide();

                });
                //*/

                $(".js-onstate-store-list-wrapper").append(storeElement);
            }

            if (i >= 5) {
                var showMore = "<div class='store-list-show-more'><a class='btn btn--secondary' href='#'>"+ theme.strings.findStoreShowMore +"</a></>";
                var showMoreElement = $(showMore);
                showMoreElement.on("click", "a", function (e) {
                    e.preventDefault();
                    $(this).closest(".store-list-show-more").hide();
                    $(".js-onstate-store-item").show();
                    return false;
                });
                $(".js-onstate-store-list-wrapper").append(showMoreElement);
            }

            if ($(window).width() < 1024) {
                $(".onstate-store-notice-wrapper").click(function(e){
                    e.preventDefault();
                    $(this).parent().find('.onstate-store-notice-message').toggleClass('hide');
                });
            }
            else {
                $(".onstate-store-notice-wrapper").hover(function(){
                    $(this).parent().find('.onstate-store-notice-message').toggleClass('hide');
                });
            }
        }
    }

    $("#store-locator .current-location").click(function(e){
        e.preventDefault();
        
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, showError);
        } else {
            $(".js-onstate-store-list-wrapper").empty().append("<div class='message'>"+ theme.strings.findStoreMessageNotSupported +"</div>");
        }

        return false;
    });

    function showPosition(position) {
        //$(".js-onstate-input-collect-postcode").val(position.coords.latitude + ", "+position.coords.longitude);
        //$("a.js-onstate-input-collect-postcode--submit").trigger("click");
        var postCodeVal = position.coords.latitude + ", "+position.coords.longitude;
        var currentLocation = true;

        $(".js-onstate-store-list-wrapper").empty().append("<div class='loading'>"+ theme.strings.findStoreLoading +"</div>");
        getStoreCollectionAddresses(postCodeVal, currentLocation).then(function(){listStoreCollectionAddresses("current location");});
    }

    function showError(error) {
        var msg = "";

        switch(error.code) {
            case error.PERMISSION_DENIED:
                msg = theme.strings.findStoreMessagePermissionDenied
                break;
            case error.POSITION_UNAVAILABLE:
                msg = theme.strings.findStoreMessagePositionUnavailable
                break;
            case error.TIMEOUT:
                msg = theme.strings.findStoreMessageTimeout
                break;
            case error.UNKNOWN_ERROR:
                msg = theme.strings.findStoreMessageUnknownError
                break;
        }

        $(".js-onstate-store-list-wrapper").empty().append("<div class='message'>"+ msg +"</div>");
    }


})(window.OsGlobals.jQuery);

function callbackStoreCollectionAddresses(data) {
    window.OsFields.inputDeliverySection.collectionAddresses = data;
}

function nullCallBack(data) {}



